<template>
    <d2-container>
        <el-form :model="form" :rules="rules" ref="form" label-width="200px">
            <el-form-item label="名称" prop="name">
                <el-input v-model="form.name" placeholder="输入名称" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-switch
                        v-model="form.status"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="开启"
                        inactive-text="关闭">
                </el-switch>
            </el-form-item>
            <el-form-item label="总库存"   prop="inventoryQuantity">
                <el-input-number
                    @change="invenChange"
                    v-model="form.inventoryQuantity"
                    placeholder="总库存"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="单价(佣金)" prop="leastCost">
                <el-input-number
                    v-model="form.price"
                    placeholder="单价"
                ></el-input-number>
            </el-form-item>

            <el-form-item label="每人最高可领(0 不限制)" prop="leastCost">
                <el-input-number
                    v-model="form.maxAmountPerPerson"
                    placeholder="最高可领"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="分享海报" prop="categoryId">
                <el-select v-model="form.posterId" filterable placeholder="请选择">
                    <el-option
                        reserve-keyword
                        v-for="item in posterList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
              <el-link style="margin-left: 10px" @click="$router.push('/demo/poster/posterEditor')" type="primary">新建海报</el-link>
            </el-form-item>
            <el-form-item label="活动页" prop="categoryId">
                <el-select v-model="form.pageId" filterable placeholder="请选择">
                    <el-option
                        reserve-keyword
                        v-for="item in pageList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
              <el-link style="margin-left: 10px" @click="$router.push('/demo/configuration/webTemplateEdit')" type="primary">新建活动页</el-link>
            </el-form-item>
            <el-form-item>
                <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
                    <div
                            style="text-align: center;color: #909399;width: 99%;margin: 2px auto;margin-bottom: 24px; "
                    >核销优惠券
                    </div>
                    <add-coupon ref="addCoupon" :disabled="form.couponId != null && form.couponVO.stat != 0" :id="form.couponId" :value="form.couponVO" @update:value="form.couponVO = $event">
                    </add-coupon>
                </div>
            </el-form-item>
        </el-form>
        <div class="footer">
            <el-button @click="$router.back()">取 消</el-button>
            <el-button type="success" @click="confirm('form')">确定</el-button>
        </div>
    </d2-container>
</template>
<script>
import {
  addKeyword,
  updateKeyword,
  getKeywordInfo,
  replyContentOption
} from '@/api/demo/helper/index'
import { getPosterList } from '@/api/demo/poster/index'
import { getToken } from '@/api/demo/classification/index'
import addCoupon from '@/components/coupons/addCoupon.vue'
import { getListcu } from '@/api/demo/webTemplateEdit'
import { addVeriOrder, getVeriOrderInfo, updateVeriOrder } from '@/api/demo/veriOrder'

export default {
  name: 'editVeriOrder',
  components: {
    addCoupon
  },
  data () {
    return {
      posterList: [],
      pageList: [],
      id: '', // id
      form: {
        status: '', // 关键字
        name: '', // 活动名称
        inventoryQuantity: 0,
        remainingQuantity: 0,
        price: 0,
        maxAmountPerPerson: 0,
        couponVO: {

        },
        posterId: null
      },

      rules: {
        inventoryQuantity: [
          {
            required: true,
            message: '请输入关键词',
            trigger: 'blur'
          }
        ],
        price: [
          {
            required: true,
            message: '请输入单价',
            trigger: 'blur'
          }
        ],
        posterId: [
          {
            required: true,
            message: '选择海报',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    let that = this
    that.id = that.$route.query.id
    if (that.id != null) {
      that.getInfo(that.id)
    }
    that.getPosterList()
    this.getPageList()
  },
  methods: {
    invenChange (val) {
      console.log(val)
      this.form.couponVO.limitCount = this.form.inventoryQuantity
    },
    getPosterList () {
      let query = {
        pageSize: 9999,
        currentPage: 1
      }
      getPosterList(query).then(res => {
        this.posterList = res.records
      })
    },
    getPageList () {
      let query = {
        pageSize: 9999,
        currentPage: 1
      }
      getListcu(query).then(res => {
        this.pageList = res.records
      })
    },
    getInfo (id) {
      let that = this
      getVeriOrderInfo(id).then(res => {
        that.form = res
      })
    },
    confirm () {
      if (this.id) {
        this.getModify('form')
      } else {
        this.getCreate('form')
      }
    },
    // 新增
    getCreate (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        if (valid) {
          that.$refs.addCoupon.verifyForm((res) => {
            console.log('res', that.form)
            if (res) {
              addVeriOrder(that.form).then(res => {
                that.$notify({
                  title: '成功',
                  message: '新增成功',
                  type: 'success',
                  duration: 2000
                })
                that.$router.back()
                // that.$router.push("/demo/helper/keyword");
              })
            }
          })
        }
      })
    },
    // 编辑
    getModify (forms) {
      let that = this
      console.log('that.form', that.form)
      that.$refs[forms].validate(valid => {
        if (valid) {
          updateVeriOrder(that.id, that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            that.$router.back()
            // that.$router.push("/demo/helper/keyword");
          })
        }
      })
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
/deep/ .el-input-number {
    margin-right: 12px;
}

.footer {
    text-align: center;
    margin-top: 20px;
}
</style>
